import React,{useCallback,useContext,useEffect, useState,useRef} from 'react';
import { getRequest, postRequest, deleteRequest } from '../../../api/ApiController';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../../assets/css/style.css';
import '../../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { MdSearch } from "react-icons/md";
import { MdSearchOff } from "react-icons/md";
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, PrintIcon, SearchIcon, ExportIcon, RefreshIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon, CalendarIcon} from "../../svg/svgIcons";
import AuthContext from "../../../components/AuthContext";
import { PanelMenu } from 'primereact/panelmenu';
import { Checkbox } from 'primereact/checkbox';
import UtilContext from "../../../components/UtilContext";
import IntersectionObserverWrapper from '../../../components/toolbar/IntersectionObserverWrap';
import { OverflowMenuProvider } from '../../../components/toolbar/OverflowMenu';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../../utils/tabulatorResetMask';
import { Avatar } from 'primereact/avatar';
import { LocaleContext } from '../../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../../utils/printChrome';
import { applyTabulatorRuntimeI18n } from '../../../utils/tabulatorRuntimeI18n';

const PAINTING_EMPLOYEE_CONDITION_LIST_COLUMN_I18N_KEYS = Object.freeze({
  name: 'PaintingEmployeeConditionList.Column.Name',
  custom_time_conditions: 'PaintingEmployeeConditionList.Column.TimeConditions',
  email_time: 'PaintingEmployeeConditionList.Column.EmailTime',
  custom_employees: 'PaintingEmployeeConditionList.Column.Employees',
  custom_other_emails: 'PaintingEmployeeConditionList.Column.OtherEmails',
});

export default function PaintingEmployeeConditionList(){

    const [state,dispatch] = useContext(DatabaseContext);
    const {user} = useContext(AuthContext);
    const { t, locale } = useContext(LocaleContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter, openChosenNotificationPreferences} = useContext(UtilContext);

    const [insertIcon,setInsertIcon] = useState(!user.permissions?.includes("add painting-setup"));
    const [editIcon,setEditIcon] = useState(true);
    const [deleteIcon,setDeleteIcon] = useState(true);
    const [favoriteIcon,setFavoriteIcon] = useState(false);
    const [copyIcon,setCopyIcon] = useState(true);
    const [searchIconColor,setSearchIconColor] = useState("");

    const [visibleSearch,setVisibleSearch] = useState(false);
    const [visibleLoading,setVisibleLoading] = useState(false);
    const [searchValue,setSearchValue] = useState('');
    const [printVisible,setPrintVisible] = useState(false);

    const DEFAULT_COLUMNS_VISIBLE_EMPLOYEE = { name: true, custom_time_conditions: true, email_time: true, custom_employees: true, custom_other_emails: true };
    const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_EMPLOYEE });
    const [maskVisible, setMaskVisible] = useState(false);

    const [markUnmark, setMarkUnmarked] = useState(true);
const [editFormPaintingTimeCondition, setEditFormPaintingTimeCondition] = useState([]);

    const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: PAINTING_EMPLOYEE_CONDITION_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    function matchAny(data, filterParams) {
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
  
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

  function searchTable(){
    ref.current.setFilter(matchAny, { value: searchValue});
    setSearchIconColor("active");
    if (searchValue === " ") {
      ref.current.clearFilter()
    }
    setVisibleSearch(false);
  }

    const accept = () => {
        let rows_to_delete = [];
        rows_to_delete = ref.current.getSelectedData();
        rows_to_delete.forEach(element => {
          console.log(element);
          deleteRequest(`/api/painting_employee_conditions/${element.id}`)
              .then((response) => {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordDeletedDetail') });
                getRequest("/api/painting_employee_conditions").then((response) => {
                  dispatch({type:'load_painting_employee_conditions',newPaintingEmployeeConditions:response.data});
              });
              }).catch((reason) => {
                  alert(reason);
                  toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.DeleteFailedDetail'), life: 3000 });
              })
        });
    }

    const reject = () => {
        toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
    }

    const confirm = () => {
        confirmDialog({
            message: t('ServiceTask.ConfirmDeleteRecord'),
            header: t('ServiceTask.ConfirmDeleteTitle'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: t('Common.No'),
            rejectLabel: t('Common.Yes'),
            accept: reject,
            reject: accept
        });
    };

  const rowClick = (e, row) => {
    console.log(e, row);
 };

    const onSelectRow = (data, rows) => {
        setEditFormPaintingTimeCondition(data);
        setEditIcon(true);
        setCopyIcon(true);
        setDeleteIcon(true);
        if(data.length !== 0){
            //TODO dorobit aj contractorov
            if(user.permissions?.includes("edit painting-setup"))setCopyIcon(false);
            if(user.permissions?.includes("edit painting-setup"))setEditIcon(false);
            if(user.permissions?.includes("delete painting-setup"))setDeleteIcon(false);
        }
    };

    function onEditRow(painting_employee_condition){
      dispatch({type:'create_new_tab',name:t('PaintingEmployeeCondition.Tab.Edit'), translationKey: 'PaintingEmployeeCondition.Tab.Edit', legacyLabel: t('PaintingEmployeeCondition.Tab.Edit'), page:'PaintingEmployeeConditionAdd',props:{painting_employee_condition: painting_employee_condition,type:'edit'},mask:'pain007'})
    };
    
    function EditRowFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
    }

    function TimeConditionsFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return rowData.time_conditions.map((item) => item.name).join(' ');
    }

    function timeConditionsHeaderFilter(headerValue, rowValue, rowData, filterParams){
      let time_conditions = rowData.time_conditions.map(item => item.name);
      for(let i = 0;i<time_conditions.length;i++){
        let filter = headerValue.toLowerCase();
        let value = time_conditions[i].toLowerCase();
        if(value.includes(filter)){
          return true
        }
      }
      return false;
    }

    function OtherEmailsFormatter(props){
      const rowData = props.cell.getRow().getData();
      if(rowData.other_emails){
        return rowData.other_emails.split(',').join('/');
      }
      else{
        return null;
      }
    }

    function EmployeesFormatter(props) {
      const rowData = props.cell.getRow().getData();
      let initials="";
      return rowData.employees.map((item) => {
        const allNames = item.name.trim().split(' ');
        if(allNames.length == 3){
          initials = allNames.reduce((acc, curr, index) => {
            if(index === allNames.length - 2 || index === allNames.length - 1){
              acc = `${acc}${curr.charAt(0).toUpperCase()}`;
            }
            return acc;
          }, '');
        }
        else{
          initials = allNames.reduce((acc, curr, index) => {
            if(index === 0 || index === allNames.length - 1){
              acc = `${acc}${curr.charAt(0).toUpperCase()}`;
            }
            return acc;
          }, '');
        }
        return <Avatar title={item.name} label={initials} shape="circle" style={{ backgroundColor: '#1d4ed8', color: '#ffffff',marginRight: '5px'}} />;
      });
    }

    function employeesHeaderFilter(headerValue, rowValue, rowData, filterParams){
      let employees = rowData.employees.map(item => item.name);
      for(let i = 0;i<employees.length;i++){
        let filter = headerValue.toLowerCase();
        let value = employees[i].toLowerCase();
        if(value.includes(filter)){
          return true;
        }
      }
      return false;
    }

    const [draggingItem,setDraggingItem] = useState(null); 
    const [columns,setColumns] = useState([
    { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center",width: 44,headerSort:false,resizable:false},
    { hozAlign:"center",width: 44,headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
    { title: t('PaintingEmployeeConditionList.Column.Name'), field: 'name',headerFilter:"input",minWidth: 200,widthGrow:1 },
    { title: t('PaintingEmployeeConditionList.Column.TimeConditions'), field: 'custom_time_conditions',headerFilter:"input",headerFilterFunc:timeConditionsHeaderFilter,minWidth: 200,formatter: reactFormatter(<TimeConditionsFormatter/>),widthGrow:1 },
    { title: t('PaintingEmployeeConditionList.Column.EmailTime'), field: 'email_time',headerFilter:"input",minWidth: 200,widthGrow:1 },
    { title: t('PaintingEmployeeConditionList.Column.Employees'), field: 'custom_employees',headerFilter:"input",headerFilterFunc:employeesHeaderFilter,minWidth: 200,formatter: reactFormatter(<EmployeesFormatter/>),widthGrow:1 },
    { title: t('PaintingEmployeeConditionList.Column.OtherEmails'), field: 'custom_other_emails',headerFilter:"input",minWidth: 200, formatter: reactFormatter(<OtherEmailsFormatter/>),widthGrow:1 },
  ]);

  const scrollToFirst = () => scrollToFirstUtil(ref.current);
  const scrollUp = () => scrollUpUtil(ref.current);
  const scrollDown = () => scrollDownUtil(ref.current);
  const scrollToLast = () => scrollToLastUtil(ref.current);
  function addNewPaintingCondition(){
    dispatch({type:'create_new_tab',name:t('PaintingEmployeeCondition.Tab.Add'), translationKey: 'PaintingEmployeeCondition.Tab.Add', legacyLabel: t('PaintingEmployeeCondition.Tab.Add'), page:'PaintingEmployeeConditionAdd',props:{painting_employee_condition: null,type:'add'},mask:'pain007'})
  }
  function copyPaintingCondition(){
    dispatch({type:'create_new_tab',name:t('PaintingEmployeeCondition.Tab.Add'), translationKey: 'PaintingEmployeeCondition.Tab.Add', legacyLabel: t('PaintingEmployeeCondition.Tab.Add'), page:'PaintingEmployeeConditionAdd',props:{painting_employee_condition: ref.current.getSelectedData()[0],type:'add'},mask:'pain007'})
  }
  function editPaintingCondition(){
    dispatch({type:'create_new_tab',name:t('PaintingEmployeeCondition.Tab.Edit'), translationKey: 'PaintingEmployeeCondition.Tab.Edit', legacyLabel: t('PaintingEmployeeCondition.Tab.Edit'), page:'PaintingEmployeeConditionAdd',props:{painting_employee_condition: ref.current.getSelectedData()[0],type:'edit'},mask:'pain007'})
  }

    function handleDragStart(e, item){ 
      setDraggingItem(item);
      e.dataTransfer.setData('text/plain', ''); 
    }; 

    function handleDragEnd(){ 
      setDraggingItem(null);
    }; 

    function handleDragOver(e){ 
        e.preventDefault(); 
    }; 

    function handleDrop(e, targetItem){ 
        if (!draggingItem) return; 

        const currentIndex = columns.indexOf(draggingItem); 
        const targetIndex = columns.indexOf(targetItem); 

        if (currentIndex !== -1 && targetIndex !== -1) { 
          columns.splice(currentIndex, 1); 
          columns.splice(targetIndex, 0, draggingItem); 
           
        } 
        ref.current.setColumns(columns);
    }; 
  
  function setMask(item,value){
    const columnVisible = {...columnsVisible};
   columnVisible[item] = value;
   console.log(columnVisible);
    for(const val in columnVisible) {
      if(columnVisible[val]==false){
        ref.current.hideColumn(`${val}`);
      }
      else{
        ref.current.showColumn(`${val}`);
      }
    }
    setColumnsVisible(columnVisible);
  }

  function changeMarkings(value){
    if(value){
      const columnVisible = {...columnsVisible};
      for(let val in columnVisible) {
        if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
          columnVisible[val]=true;
          ref.current.showColumn(`${val}`);
        }
      };
      setColumnsVisible(columnVisible);
    }
    else{
      const columnVisible = {...columnsVisible};
      for(let val in columnVisible) {
        if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
          columnVisible[val]=false;
          ref.current.hideColumn(`${val}`);
        }
      };
      setColumnsVisible(columnVisible);
    }
  }

  const resetMask = () => resetTabulatorMask({
    page: 'PaintingEmployeeConditionList',
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_EMPLOYEE,
    ref, columns, setColumnsVisible,
  });

  const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
        {
          key: '0_1',
          label: t('Common.SetFilter'),
          icon: 'pi pi-filter',
          command: () => {setUserMaskFilter("PaintingEmployeeConditionList","set_filters",null,ref.current.getHeaderFilters(),null);},
          template: itemRenderer,
      },
        {
          key: '0_2',
          label: t('Common.ClearFilter'),
          icon: 'pi pi-filter-slash',
          command: () => {setUserMaskFilter("PaintingEmployeeConditionList","set_filters",null,[],null);ref.current.clearHeaderFilter();},
          template: itemRenderer,
      },
      {
          key: '0_3',
          label: t('Common.SetSorting'),
          icon: 'pi pi-sort-alt',
          command: () => {setUserMaskFilter("PaintingEmployeeConditionList","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
          template: itemRenderer,
      },
      {
          key: '0_4',
          label: t('Common.ClearSorting'),
          icon: 'pi pi-sort-alt-slash',
          command: () => {setUserMaskFilter("PaintingEmployeeConditionList","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
          template: itemRenderer,
      },
      {
          key: '0_5',
          label: t('Common.SetMask'),
          icon: 'pi pi-server',
          command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
          template: itemRenderer,
      },
      {
          key: '0_5b',
          label: t('Common.ResetUserMask'),
          icon: 'pi pi-refresh',
          command: () => {resetMask();OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
          template: itemRenderer,
      },
      {
        key: '0_6',
        label: t('Common.Notifications'),
        icon: 'pi pi-envelope',
        command: () => {openChosenNotificationPreferences('PaintingEmployeeConditionList');OverflowMenuProvider.setVisible(null);},
        template: itemRenderer,
    },
      ]
    }
  ];return(
      <>
      <div className='w-full h-10 flex flex-row bg-[#333]'>
        <IntersectionObserverWrapper>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="add"><button className="disabled:opacity-25" disabled={insertIcon} onClick={() => addNewPaintingCondition()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editPaintingCondition()}><EditIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyPaintingCondition()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="print"><button onClick={() => setPrintVisible(true)}><PrintIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="search"><button onClick={searchIconColor!="active"? () => {setVisibleSearch(true);}:() => {setSearchIconColor("");setSearchValue("");ref.current.clearFilter();}}>{searchIconColor == "" ?  <MdSearch fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.Search')}/> : <MdSearchOff fill='#fff' strokeWidth="0" className='w-[28px] h-[28px]' aria-hidden="true" title={t('Common.CancelSearch')}/>}</button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="export"><button onClick={() => ref.current.download("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="refresh"><button onClick={() => getRequest("/api/painting_employee_conditions").then((response) => dispatch({ type: 'load_painting_employee_conditions', newPaintingEmployeeConditions: response.data }))} title={t('Common.Refresh')}><RefreshIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog("Podmienky lakovania","PaintingConditionList")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center ' data-targetid="fast"><button onClick={() => setFastView("PaintingConditionList",columnsVisible,columns)}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '  data-targetid="vert"><VerticalLineIcon/></div>
          <div className="card flex justify-content-center z-[100] " data-targetid="actions" ref={overlayRef}>
            <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
          </div>
    </IntersectionObserverWrapper>
      </div>
<div className='px-1 bg-white rounded-md shadow-md'>
<div className="flex flex-col overflow-x-auto no-scrollbar min-h-[calc(100vh-177px)]">
<div className="overflow-hidden">
  <div className="inline-block w-full py-2" >
    <div ref={elementRef}>
      <ReactTabulator
      data={state.painting_employee_conditions} 
      className='h-[calc(100vh_-_193px)]' //176px
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          let mask = (state.user_mask_filters || []).filter(mask => mask.page=="PaintingEmployeeConditionList");
          const safeParse = (v, fallback) => {
              if (v === null || v === undefined) return fallback;
              if (typeof v === "string") {
              try { return JSON.parse(v); } catch { return fallback; }
              }
              return v; // už je array/object
          };
          if (mask.length > 0) {
              const attributes  = safeParse(mask[0].attributes, []);
              const filters     = safeParse(mask[0].filters, []);
              const sorters     = safeParse(mask[0].sorters, []);
              const json_columns = safeParse(mask[0].columns, {});
              if (Array.isArray(attributes) && attributes.length > 1) {
                  ref.current.setColumnLayout(attributes);
              }
              if (Array.isArray(filters)) {
                  filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
              }
              if (Array.isArray(sorters) && sorters.length > 0) {
                  ref.current.setSort(sorters);
              }
              if (json_columns && typeof json_columns === "object") {
                  setColumnsVisible(json_columns);
                  for (let column in json_columns) {
                      if (json_columns[column] === false) ref.current.hideColumn(column);
                      else ref.current.showColumn(column);
                  }
              }
          }
        },
        columnMoved:() => {
          setUserMaskFilter("PaintingEmployeeConditionList","column_move",null,null,ref.current.getColumnLayout());
        },
        columnResized:() => {
          setUserMaskFilter("PaintingEmployeeConditionList","column_move",null,null,ref.current.getColumnLayout());
        },
      }}
      options={{layout:"fitColumns",
      renderHorizontal:"virtual",movableColumns: true,rowHeight: 42,
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('PaintingEmployeeConditionList'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active"}}/> 
    </div> 
  </div> 
</div> 
</div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
        <div className="flex flex-col">
        <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
        {columns.map(function(item, index){ 
          if(index<2) return null;
                    return <div 
                        key={index} 
                        className="flex flex-row border border-black rounded-md p-2 m-1"
                    > 

                         <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                          
                        {/* Use the React icon component */} 
                    </div> 
                })}
                 <button onClick={() => {setUserMaskFilter("PaintingEmployeeConditionList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('TaskTemplateList.MaskSave')}</button>
        </div>
      </Dialog>
      
      </div> 
 </>
    )

}